module.exports = __webpack_public_path__ + "media/sub3-6-4.13ee4982.mp4";